import { render, staticRenderFns } from "./PromoTable.vue?vue&type=template&id=23dee28c&scoped=true"
import script from "./PromoTable.vue?vue&type=script&lang=js"
export * from "./PromoTable.vue?vue&type=script&lang=js"
import style0 from "./PromoTable.vue?vue&type=style&index=0&id=23dee28c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dee28c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23dee28c')) {
      api.createRecord('23dee28c', component.options)
    } else {
      api.reload('23dee28c', component.options)
    }
    module.hot.accept("./PromoTable.vue?vue&type=template&id=23dee28c&scoped=true", function () {
      api.rerender('23dee28c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/gift/components/PromoTable.vue"
export default component.exports